/*
 * 工单管理组件
 * zxw
 * 创建时间：
 * 修改时间：2026-07-08
*/

import React, { useState, useEffect, useCallback, useMemo } from 'react';
import $ from 'jquery';
import CNF from '../../incs/Config';
import {
    Row,
    Col,
    message,
    Table,
    Input,
    Select,
    Modal,
    Button,
    Upload,
    DatePicker,
    Tag,
    Space,
    Statistic,
    theme,
    Progress,
} from 'antd';
import { PlusOutlined, ExportOutlined, ImportOutlined, LoadingOutlined } from '@ant-design/icons';
import {
    UjoinParams,
    AddRequestHeaders,
    DateFormat,
    winWidth,
    ShowIPModal,
    isGTscreenWidth,
    GetDropdownActionName,
    GetArrSpanMaxWidth,
} from '../../incs/FunHelper.js';
import ExportJsonExcel from 'js-export-excel';

import ProductInfo from '../../components/ProductInfo';
import WOInfo from './WOInfo.js';
import Entity from './WOEntity';
import WOVisitEntity from './WOVisitEntity';

const MODULENAME = CNF.navItems[2].submenu[0].name.replace('管理', '');
const MODULENAME_PTN = CNF.navItems[2].submenu[0].ptn;
const MODULENAME_URL = CNF.navItems[2].submenu[0].url;

const { RangePicker } = DatePicker;

const Lists = (props) => {
    const { btnLists, preGroup, dataLists, currentIndex, pageCount, changeIndex, setOpen, refresh, qss } = props;

    const {
        token: {
            colorPrimary,
            colorPrimaryBg,
            colorSuccess,
            colorSuccessBg,
            fontSize,
            pageSize,

        },
    } = theme.useToken();

    const update = useCallback((record) => {
        setOpen(true, record);
    }, [setOpen]);

    const [record, setRecord] = useState(null);
    const [openWOInfoModel, setOpenWOInfoModel] = useState(false);
    const [openProductInfoModel, setOpenProductInfoModel] = useState(false);
    const [openVisitModel, setOpenVisitModel] = useState(false);


    /**
     * 显示工单信息
     * @param {*} record 
     */
    const showWOInfo = useCallback((record) => {
        setRecord(record);
        setOpenWOInfoModel(true);
    }, []);

    /**
     * 显示产品信息
     * @param {*} record 
     */
    const shwoProductInfo = useCallback((record) => {
        setRecord(record);
        setOpenProductInfoModel(true);
    }, []);

    const visit = useCallback((record) => {
        setRecord(record);
        setOpenVisitModel(true);
    }, []);


    /**
     * 操作选项
     * @param {*} action 
     * @param {*} record 
     */
    const operation = useCallback((action, record) => {
        const uri = MODULENAME_URL.slice(1) + '/' + record.key;
        switch (action) {
            case CNF.actionName.VISIT:
                visit(record);
                break;
            case CNF.actionName.UPDATE:
                update(record);
                break;
            case CNF.actionName.DISABLE:
            case CNF.actionName.ACTIVE:
            case CNF.actionName.DELETE:
                ShowIPModal(record.key, record.number, action, MODULENAME, refresh, uri);
                break;
            default:
                break;
        }
    }, [refresh, visit, update]);

    const hasOpPerm = (
        btnLists.indexOf(MODULENAME_PTN + '_visit') > 0 ||
        btnLists.indexOf(MODULENAME_PTN + '_update') > 0 ||
        btnLists.indexOf(MODULENAME_PTN + '_disable') > 0 ||
        btnLists.indexOf(MODULENAME_PTN + '_active') > 0 ||
        btnLists.indexOf(MODULENAME_PTN + '_delete') >= 0
    );

    const columns = useMemo(() => [
        { title: '', width: 20, dataIndex: '', key: 'key', fixed: 'left', },
        {
            title: '工单编号', key: 'number', fixed: 'left', width: 150,
            render: (record) => <Button
                color='primary'
                variant='link'
                style={{ padding: '0 5px', border: 0, height: 22 }}
                onClick={() => { showWOInfo(record); }}>{record.number}</Button>
        },
        {
            title: '工单等级', key: 'level', width: 100, fixed: 'left',
            render: function (record) {
                for (let item of CNF.woLevels) {
                    if (parseInt(record.level) === parseInt(item.value)) {
                        return item.key
                    }
                }
            }
        },
        { title: '工单类型', dataIndex: 'type', key: 'type', width: 100, },
        {
            title: '绩效权重', key: 'perf_weight', width: 100, hidden: true,
            render: (record) => <Tag color={colorPrimaryBg} style={{ width: '60%' }}><Statistic precision={1} styles={{ content: { fontSize: fontSize - 2, color: colorPrimary } }} value={record.perf_weight} /></Tag>
        },
        { title: '所属项目', dataIndex: 'project_name', key: 'project_name', width: GetArrSpanMaxWidth(dataLists, 'project_name'), },
        { title: '工单点位', dataIndex: 'point', key: 'point', width: GetArrSpanMaxWidth(dataLists, 'point'), },
        { title: '处理开始时间', dataIndex: 'start_time', key: 'start_time', width: 200, },
        { title: '处理结束时间', dataIndex: 'end_time', key: 'end_time', width: 200, },
        {
            title: '维护支出', key: 'out_fee', width: 100,
            render: (record) => <Tag color={colorPrimaryBg} style={{ width: '80%' }}><Statistic precision={CNF.DPL} styles={{ content: { fontSize: fontSize - 2, color: colorPrimary } }} value={record.out_fee} /></Tag>
        },
        {
            title: '维护收入', key: 'in_fee', width: 100,
            render: (record) => <Tag color={colorSuccessBg} style={{ width: '80%' }}><Statistic precision={CNF.DPL} styles={{ content: { fontSize: fontSize - 2, color: colorSuccess } }} value={record.in_fee} /></Tag>
        },
        {
            title: '工单权重', key: 'perf_weight', width: 100,
            render: (record) => <Tag color={colorPrimaryBg} style={{ width: '60%' }}><Statistic precision={1} styles={{ content: { fontSize: fontSize - 2, color: colorPrimary } }} value={record.perf_weight} /></Tag>
        },
        { title: '处理人员', dataIndex: 'do_user', key: 'do_user', width: GetArrSpanMaxWidth(dataLists, 'do_user', 120), },
        {
            title: '产品编码', key: 'product_number', width: 180,
            render: (record) => record.product_number ? <Button
                color='primary'
                variant='link'
                style={{ padding: '0 5px', border: 0, height: 22 }}
                onClick={() => { shwoProductInfo(record); }}>{record.product_number}</Button> : '-'
        },
        { title: '创建时间', dataIndex: 'create_time', key: 'create_time', width: CNF.tableCreateTimeColumnWidth, },
        { title: '创建者', dataIndex: 'create_displayname', key: 'create_displayname', width: CNF.tableCreateDisplayeColumnWidth, },
        { title: '回访状态', dataIndex: 'visit_status', key: 'visit_status', width: CNF.tableStatusColumnWidth, },
        { title: '状态', dataIndex: 'status', key: 'status', width: CNF.tableStatusColumnWidth, },
        {
            title: '', key: 'operation', fixed: 'right', width: CNF.tableOperationColumnWidth, hidden: !hasOpPerm,
            render: (record) => GetDropdownActionName(btnLists, MODULENAME_PTN, record, operation)
        }
    ], [btnLists, dataLists, colorPrimary, colorPrimaryBg, colorSuccess, colorSuccessBg, fontSize, hasOpPerm, operation, showWOInfo, shwoProductInfo]);
    return (
        <>
            <Table
                columns={columns}
                size='middle'
                dataSource={dataLists}
                scroll={{ x: winWidth }}
                pagination={{
                    showSizeChanger: false,
                    showQuickJumper: false,
                    showTotal: () => <Space>
                        支出: <Tag color={colorPrimaryBg}><Statistic precision={CNF.DPL} suffix={qss?.out_fee > 10000 ? '万元' : '元'} styles={{ content: { fontSize: fontSize - 2, color: colorPrimary } }} value={qss?.out_fee > 10000 ? qss.out_fee / 10000 : qss?.out_fee} /></Tag>
                        收入: <Tag color={colorSuccessBg}><Statistic precision={CNF.DPL} suffix={qss?.in_fee > 10000 ? '万元' : '元'} styles={{ content: { fontSize: fontSize - 2, color: colorSuccess } }} value={qss?.in_fee > 10000 ? qss.in_fee / 10000 : qss?.in_fee} /></Tag>
                        共{pageCount > 10000 ? (pageCount / 10000).toFixed(CNF.DPL) + '万' : props.pageCount}条
                    </Space>,
                    pageSize: pageSize,
                    current: currentIndex,
                    total: pageCount,
                    onShowSizeChange: (current, pageSize) => props?.changePageSize(pageSize, current),
                    onChange: (current) => changeIndex(current),
                }}
            />
            {openWOInfoModel && record && <WOInfo
                preGroup={preGroup}
                btnLists={btnLists}
                open={openWOInfoModel}
                setOpen={setOpenWOInfoModel}
                record={record}
            />
            }
            {openProductInfoModel && record && <ProductInfo
                preGroup={preGroup}
                btnLists={btnLists}
                open={openProductInfoModel}
                setOpen={setOpenProductInfoModel}
                productNumber={record.product_number}
            />
            }
            {openVisitModel && record && <WOVisitEntity
                open={openVisitModel}
                setOpen={setOpenVisitModel}
                record={record}
            />
            }
        </>
    );
}

const WO = (props) => {
    const { btnLists, preGroup } = props;

    const { token: { pageSize, }, } = theme.useToken();

    const [loading, setLoading] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();
    const [triggerRefresh, setTriggerRefresh] = useState(0);
    const [currentIndex, setCurrentIndex] = useState(1);
    const [pageCount, setPageCount] = useState(0);
    const [dataLists, setDataLists] = useState([]);
    const [record, setRecord] = useState(null);
    const [open, setOpen] = useState(false);
    const [visitStatus, setVisitStatus] = useState('');
    const [status, setStatus] = useState(CNF.status[0].value);
    const refresh = useCallback(() => {
        setTriggerRefresh((prev) => prev + 1);
    }, []);

    const [qss, setQss] = useState(null);
    const [number, setNumber] = useState('');
    const [projectLists, setProjectLists] = useState([]);
    const [projectUlid, setProjectUlid] = useState('');
    const [level, setLevel] = useState(0);
    const [type, setType] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [doUser, setDoUser] = useState('');

    const changeIndex = useCallback((index) => {
        setCurrentIndex(index);
    }, []);

    const handleStatusChange = useCallback((value) => {
        setStatus(value || '');
        setCurrentIndex(1);
    }, []);

    const handleNumberChange = useCallback((e) => {
        setNumber(e.target.value);
        setCurrentIndex(1);
    }, []);

    const handleProjectUlidChange = useCallback((value) => {
        setProjectUlid(value);
        setCurrentIndex(1);
    }, []);

    const handleLevelChange = useCallback((value) => {
        setLevel(value);
        setCurrentIndex(1);
    }, []);

    const handleTypeChange = useCallback((value) => {
        setType(value);
        setCurrentIndex(1);
    }, []);

    const handleTimeIntervalChange = useCallback((_, dateString) => {
        setStartDate(dateString ? dateString[0] : '');
        setEndDate(dateString ? dateString[1] : '');
        setCurrentIndex(1);
    }, []);

    const handleDoUserChange = useCallback((e) => {
        setDoUser(e.target.value);
        setCurrentIndex(1);
    }, []);

    const handleVisitStatusChange = useCallback((value) => {
        setVisitStatus(value || '');
        setCurrentIndex(1);
    }, []);

    const setOpenModal = useCallback((value, record) => {
        setOpen(value);
        setRecord(record || null);
    }, []);

    const create = useCallback(() => {
        setOpenModal(true, null);
    }, [setOpenModal]);

    useEffect(() => {
        /***
         * 获取项目下拉列表
         */
        const projectDDList = () => {
            const params = {
                rss: 'list',
                page_size: CNF.maxPageSize,
                current_index: 1
            };
            $.ajax({
                url: `${CNF.api}projects/bases${UjoinParams(params)}`,
                headers: AddRequestHeaders(),
                crossDomain: true,
                type: 'GET',
            }).done((data) => {
                if (data.res === 0) {
                    setProjectLists(data.dat || []);
                } else {
                    messageApi.error(data.msg, CNF.messageDuration);
                }
            }).fail((err) => {
                messageApi.error(err.responseJSON?.detail || '请求失败', CNF.messageDuration);
            })
        }
        projectDDList();
    }, [messageApi]);

    useEffect(() => {
        setLoading(true);

        let params = {
            page_size: pageSize,
            current_index: currentIndex,
            status,
            number,
            project_ulid: projectUlid,
            do_user: doUser,
            level,
            type,
            start_date: startDate,
            end_date: endDate,
            visit_status: visitStatus,
        };

        // 注意：如果 0 也是有效值，需要额外处理，但此处页码和数量通常不为0或空
        params = Object.fromEntries(
            Object.entries(params).filter(([_, value]) => value !== '' && value !== null && value !== undefined)
        );

        $.ajax({
            url: `${CNF.api}${MODULENAME_URL.slice(1)}${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET',
        }).done((data) => {
            if (data.res === 0) {
                setDataLists(data.dat || []);
                setPageCount(data.cnt || 0);
                setQss(data.qss || null);
            } else {
                messageApi.error(data.msg, CNF.messageDuration);
            }
        }).fail((err) => {
            messageApi.error(err.responseJSON?.detail || '请求失败', CNF.messageDuration);
        }).always(() => setLoading(false))
    }, [messageApi, pageSize, currentIndex, triggerRefresh, status, number, projectUlid, doUser, level, type, startDate, endDate, visitStatus]);

    // ---------- 导入相关 ----------
    const [modal, modalContextHolder] = Modal.useModal();
    const [instance, setInstance] = useState(null);

    /**
     * 导入前检查
     * @param {*} info 
     * @returns 
     */
    const uploadCheck = useCallback((info) => {
        if (info.size > 10240000) {
            messageApi.error('上传文件超过10M，建议拆分文件！', CNF.messageDuration);
            return false;
        }
        if (!info.name.match(/.xls[x]{0,1}/)) {
            messageApi.error('文件格式不对，只支持 xls 或 xlsx ！', CNF.messageDuration);
            return false;
        }
        setInstance(
            modal.info({
                width: isGTscreenWidth ? 500 : 600,
                title: <Space>文件正在上传<LoadingOutlined /></Space>,
                content: <Progress percent={0} />,
                footer: null,
                icon: null,
                keyboard: false,
                closable: false,
            })
        );
        return true;
    }, [messageApi, modal]);

    /**
     * 更新导入弹框
     * @param {*} modal 
     * @param {*} title 
     * @param {*} data 
     * @param {*} percent 
     * @param {*} status 
     */
    const updateModal = useCallback((modalInstance, title, data, percent, status) => {
        modalInstance.update((prevConfig) => ({
            ...prevConfig,
            title,
            content: (
                <>
                    <Progress percent={percent} style={{ width: '100%' }} />
                    <Row style={{ marginTop: CNF.rowMarginTop }}>
                        <Col span={4}><strong>表格行号</strong></Col>
                        <Col span={12}><strong>工单编号</strong></Col>
                        <Col span={8}><strong>操作说明</strong></Col>
                    </Row>
                    <div
                        id='import-modal-id'
                        style={{
                            height: 360,
                            marginTop: CNF.rowMarginTop,
                            overflowY: 'auto',
                        }}
                    >
                        {data.map((item, index) => (
                            <Row style={{ lineHeight: 2 }} key={index}>
                                <Col span={4}>{item.key}</Col>
                                <Col span={12}>{item.number}</Col>
                                <Col span={8} style={{ color: item.msg.includes('成功') ? '#000' : item.msg.includes('已导入') ? 'green' : 'red' }}>
                                    {item.msg}
                                </Col>
                            </Row>
                        ))}
                    </div>
                    {status === 'done' && (
                        <div style={{ marginTop: CNF.rowMarginTop * 2, width: '100%', textAlign: 'right' }}>
                            <Button
                                title='确定'
                                variant='solid'
                                style={{ background: global.THEMECOLOR, color: '#fff', border: 0 }}
                                onClick={() => {
                                    modalInstance.destroy();
                                    refresh();
                                }}
                            >
                                确定
                            </Button>
                        </div>
                    )}
                </>
            ),
        }));
    }, [refresh]);

    /**
     * 获取任务
     * @param {*} modal 
     * @param {*} jobId 
     */
    const getJob = useCallback(
        async (modalInstance, jobId) => {
            instance?.update((prevConfig) => ({
                ...prevConfig,
                title: <Space>{MODULENAME}正在导入<LoadingOutlined /></Space>,
                content: <Progress percent={0} />,
            }));

            const messageData = [];
            let total = 0;          // 总记录数（首次获取后固定）
            let processed = 0;      // 已处理记录数（累加）

            try {
                const response = await fetch(CNF.api + 'wos/tasks?job_id=' + jobId, {
                    method: 'GET',
                    headers: AddRequestHeaders(),
                    openWhenHidden: true,
                });
                if (!response.ok) {
                    // 处理错误
                }
                const reader = response.body.getReader();
                const td = new TextDecoder('utf-8');
                let jsonData = null;
                while (true) {
                    const { done, value } = await reader.read();
                    const text = td.decode(value, { stream: true });
                    const jsonMatch = text.match(/data:\s*({.*?})\s*\n/);

                    // 计算进度（避免除零）
                    const percent = total > 0 ? (processed / total) * 100 : 0;
                    const percentFixed = parseFloat(percent.toFixed(CNF.DPL));

                    if (jsonMatch) {
                        jsonData = JSON.parse(jsonMatch[1]);
                    } else {
                        // 无有效数据，继续等待
                        if (done) {
                            // 更新进度
                            updateModal(
                                modalInstance,
                                `${MODULENAME}导入结束！`,
                                messageData,
                                percentFixed,
                                'done'
                            );
                            break
                        };
                        continue;
                    }

                    // 若服务端返回错误，直接终止
                    if (jsonData.res !== 0) {
                        modalInstance.destroy();
                        messageApi.error(jsonData.msg, CNF.messageDuration);
                        break;
                    }

                    // 首次获取 total，之后固定
                    if (total === 0 && jsonData.total) {
                        total = jsonData.total;
                    }

                    // 累加本批次记录数
                    const batchData = jsonData.data || [];
                    if (batchData.length) {
                        messageData.push(...batchData);
                        processed += batchData.length;
                    }

                    // 判断是否完成（服务端标识完成 或 已处理数达到总数）
                    const isFinished = jsonData?.id === jsonData?.total || processed >= total;

                    if (done || isFinished) {
                        // 完成时强制 100%
                        updateModal(
                            modalInstance,
                            isFinished ? `${MODULENAME}导入完成！` : `${MODULENAME}导入结束！`,
                            messageData,
                            100,
                            'done'
                        );
                        break;
                    } else {
                        // 更新进度
                        updateModal(
                            modalInstance,
                            <Space>{MODULENAME}正在导入<LoadingOutlined /></Space>,
                            messageData,
                            percentFixed,
                            'running'
                        );
                    }

                    // 滚动至底部
                    const div = document.getElementById('import-modal-id');
                    if (div) {
                        div.scrollTop = div.scrollHeight;
                        div.style.scrollBehavior = 'smooth';
                        div.scrollTo(0, div.scrollHeight);
                    }
                }
            } catch (e) {
                instance?.update((prevConfig) => ({
                    ...prevConfig,
                    closable: true,
                    onCancel: () => refresh(),
                }));
                messageApi.error('网络错误 !', CNF.messageDuration);
            }
        },
        [instance, messageApi, updateModal, refresh]
    );

    /**
     * 执行导入
     * @param {*} info 
     */
    const upload = useCallback(
        (info) => {
            if (info.file.status === 'uploading') {
                instance?.update((prevConfig) => ({
                    ...prevConfig,
                    content: <Progress percent={parseFloat(info.file.percent).toFixed(CNF.DPL)} />,
                }));
            } else if (info.file.status === 'done') {
                instance?.update((prevConfig) => ({
                    ...prevConfig,
                    title: '文件上传完成！',
                    content: <Progress percent={100} />,
                }));
                if (info.file.response?.dat) {
                    setTimeout(() => {
                        getJob(instance, info.file.response.dat.job_id);
                    }, 1000);
                } else {
                    instance?.destroy();
                    messageApi.error(info.file.response?.msg || '上传失败', CNF.messageDuration);
                }
            } else if (info.file.status === 'error') {
                instance?.destroy();
                messageApi.error(`${info.file.name} 导入失败！`, CNF.messageDuration);
            }
        },
        [instance, getJob, messageApi]
    );

    // ---------- 导出相关 ----------
    /***
    * 导出 Excel
    */
    const exportAsExcel = (data) => {
        var date = new Date();
        let option = {};  //    option代表的就是excel文件
        option.fileName = '工单信息明细-' + DateFormat('YYYY-mm-dd', date);  //   excel文件名称
        option.datas = [
            {
                sheetData: data,  //   excel文件中的数据源
                sheetName: '工单信息明细',  //  excel文件中sheet页名称
                sheetHeader: [
                    '工单编号',
                    '项目名称',
                    '产品编码',
                    '工单描述',
                    '工单点位',
                    '工单等级',
                    '绩效权重',
                    '开始时间',
                    '结束时间',
                    '工单原因',
                    '处理方式',
                    '维护支出',
                    '维护收入',
                    '处理人员',
                    '工单类型',
                    '是否回访',
                    '状态',
                    '备注'],  //  excel文件中每列的表头名称
            }
        ]
        let toExcel = new ExportJsonExcel(option);  //生成excel文件
        toExcel.saveExcel();  //下载excel文件
    }

    /***
     * 获取导出明细
     */
    const exportGetData = () => {
        const params = {
            status: status,
            page_size: 65535,
            current_index: 1,
            number: number,
            project_ulid: projectUlid,
            level: level,
            type: type,
            start_date: startDate,
            end_date: endDate,
            do_user: doUser,
            visit_status: visitStatus,
        }

        $.ajax({
            url: `${CNF.api}wos${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET', success: function (data) {
                if (data.res === 0) {
                    if (data.dat.length > 0) {
                        //  删除非必须字段
                        var d = [];
                        for (let i = 0; i < data.dat.length; i++) {
                            var item = data.dat[i]
                            delete item['key'];
                            delete item['project_ulid'];
                            delete item['create_username']
                            delete item['create_displayname']
                            delete item['create_time']
                            delete item['update_time']
                            d.push(item);
                        }
                        exportAsExcel(d);
                    } else {
                        exportAsExcel([]);
                    }
                } else {
                    messageApi.error(data.msg, CNF.messageDuration);
                }
            }
        })
    }

    // 按钮权限判断
    const hasCreate = btnLists.includes(MODULENAME_PTN + '_create');
    const hasImport = btnLists.includes(MODULENAME_PTN + '_import');
    const hasExport = btnLists.includes(MODULENAME_PTN + '_export');

    return (
        <>
            {contextHolder}
            {modalContextHolder}
            <Space style={{ padding: CNF.searchMarginLeft * 4 }}>
                <Input
                    placeholder='工单编号'
                    style={{ width: 100 }}
                    onChange={handleNumberChange}
                    value={number}
                />
                <Select
                    showSearch
                    allowClear
                    placeholder='请选择项目'
                    style={{ minWidth: 300 }}
                    onChange={handleProjectUlidChange}
                    filterOption={(input, option) => option.props.children.indexOf(input) >= 0}
                    options={projectLists && projectLists.map((item, index) => ({
                        key: index,
                        value: item.key,
                        label: item.name,
                    }))}
                />
                <Select
                    placeholder='工单等级'
                    style={{ width: '100%' }}
                    onChange={handleLevelChange}
                    options={CNF.woLevels.map((item, index) => ({
                        key: index,
                        value: item.value,
                        label: item.key
                    }))}
                />
                <Select
                    placeholder='工单类型'
                    style={{ width: '100%' }}
                    onChange={handleTypeChange}
                    options={CNF.woTypes.map((item, index) => ({
                        key: index,
                        value: item.value,
                        label: item.key
                    }))}
                />
                <RangePicker
                    placeholder={['开始日期', '结束日期']}
                    style={{ width: '100%' }}
                    format='YYYY-MM-DD'
                    onChange={handleTimeIntervalChange}
                />
                <Input
                    placeholder='处理人员'
                    style={{ width: 100 }}
                    onChange={handleDoUserChange}
                    value={doUser}
                />
                <Select
                    allowClear
                    placeholder='回访状态'
                    style={{ width: '100%' }}
                    onChange={handleVisitStatusChange}
                    value={visitStatus ? visitStatus : undefined}
                    options={CNF.visitStatus.map((item, index) => ({
                        key: index,
                        value: item.value,
                        label: item.label
                    }))}
                />
                <Select
                    allowClear
                    placeholder='状态'
                    style={{ width: '100%' }}
                    onChange={handleStatusChange}
                    value={status ? status : undefined}
                    options={CNF.status.map((item, index) => ({
                        key: index,
                        value: item.value,
                        label: item.label
                    }))}
                />
                {hasCreate && (
                    <Button
                        title={CNF.actionName.CREATE + MODULENAME}
                        color='primary'
                        variant='solid'
                        icon={<PlusOutlined />}
                        onClick={() => {
                            create();
                        }}>
                        {CNF.actionName.CREATE}
                    </Button>
                )}
                {hasImport && (
                    <Upload
                        action={CNF.api + 'wos/tasks'}
                        headers={AddRequestHeaders(false)}
                        onChange={upload}
                        beforeUpload={uploadCheck}
                        showUploadList={false}
                        name='file'
                        accept='xlsx,xls,cvs'
                    >
                        <Button
                            title={CNF.actionName.IMPORT + MODULENAME}
                            color='primary'
                            variant='solid'
                            icon={<ImportOutlined />}>
                            {CNF.actionName.IMPORT}
                        </Button>
                    </Upload>

                )}
                {hasExport && (
                    <Button
                        title={CNF.actionName.EXPORT + MODULENAME}
                        color='primary'
                        variant='solid'
                        icon={<ExportOutlined />}
                        onClick={() => {
                            exportGetData();
                        }}>
                        {CNF.actionName.EXPORT}
                    </Button>
                )}
            </Space>
            <Lists
                btnLists={btnLists}
                preGroup={preGroup}
                dataLists={dataLists}
                currentIndex={currentIndex}
                pageCount={pageCount}
                changeIndex={changeIndex}
                setOpen={setOpenModal}
                refresh={refresh}
                loading={loading}
                qss={qss}
            />
            <Entity
                preGroup={preGroup}
                btnLists={btnLists}
                open={open}
                record={record}
                setOpen={setOpenModal}
                refresh={refresh}
                projectLists={projectLists}
            />
        </>
    );
}

export default WO